import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchCallers, fetchBlockAssignments } from '../../lib/api';

export function useCallers(status) {
  return useQuery({
    queryKey: queryKeys.callers(status),
    queryFn: () => fetchCallers(status),
  });
}

export function useBlockAssignments(campaignId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.blockAssignments(campaignId),
    queryFn: () => fetchBlockAssignments(campaignId),
    enabled,
  });
}
